export const mvpLimits = {
  maxCharacters: 20,
  // Base ceiling for an original one-shot generation. Continuation raises the
  // effective ceiling per pass — see scenesPerContinuation and effectiveMaxScenes.
  maxScenes: 30,
  // Extra scene headroom each continuation ("догенерация") pass adds on top of
  // maxScenes, so a continued novel can grow past the base limit.
  scenesPerContinuation: 30,
  maxEndings: 10,
  maxChoicesPerScene: 5,
  maxSceneTextLength: 5000,
  /** Max characters on stage in one scene section (the pair the beat focuses on). */
  maxSectionCharacters: 2,
  /** Max sections (reading beats) in one scene's timeline. */
  maxSectionsPerScene: 150,
  /** Max cues (sounds, frame replacements) on one section. */
  maxSectionCues: 6,
  /** Max traits a character can carry (Sims-style trait picker). */
  maxTraits: 5,
  /** Max machine-translation languages a single novel can carry. */
  maxTranslationLanguages: 8
} as const;

/**
 * Longest art-style note (characters) a novel may carry: the author's short
 * style phrase ("watercolour, muted autumn palette") that the model expands into
 * the novel's one art-style descriptor. The one cap for every place a note is
 * entered or accepted — the Create page, the editor's Settings, the generation
 * job and `POST /api/novels/:id/expand-art-style` — so a note saved by one is
 * never refused by another.
 */
export const MAX_ART_STYLE_NOTES_CHARS = 2000;
